// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2azAQfUI","logo":"Fzddoche","app":"MHQi3cIE","app__name":"DTdG7rRf","app__description":"R55Ljlgb","app__rating":"bArXvYcB","app__rating_text":"_Z808x0j"};